import {
  resolveMessageMedia,
  type ChatMessage,
} from '@teo/widget-shared';
import { resolveMessageReactKey } from './image-display-cache.js';
import { messageRenderFingerprint } from './sync-logger.js';

/** Skip React state update when sync would not change anything visible in the list. */
export function shouldPreserveMessageListSnapshot(
  previous: ChatMessage[],
  next: ChatMessage[],
): boolean {
  if (previous === next) return true;
  if (previous.length !== next.length) return false;

  for (let index = 0; index < previous.length; index += 1) {
    if (
      messageRenderFingerprint(previous[index]!) !==
      messageRenderFingerprint(next[index]!)
    ) {
      return false;
    }
  }

  return true;
}
